import { WebViewUI } from "@/components/webview-ui";
import { appUrl } from "@/constants";
import { Linking } from "react-native";

export default function HelpCenterScreen() {
    const termsUrl = `${appUrl}/mobile/faqs`;

    return (
        <WebViewUI title="Help Center" url={termsUrl} showMenu={true} handleShouldStartLoadWithRequest={(request) => {
            if (request.url.startsWith('tel:')) {
                Linking.openURL(request.url);
                return false; // prevent WebView from loading it
            }
            if (request.url.startsWith('mailto:')) {
                Linking.openURL(request.url);
                return false; // prevent WebView from loading it
            }
            return true;

        }} />
    );
}
